import { Box, Card, Grid, SxProps, Theme } from '@mui/material';
import isEmpty from 'lodash-es/isEmpty';
import React from 'react';

import WsColors from '../../WsColors';
import { WsButton, WsButtonProps } from '../WsButton';
import { WsTypography, WsTypoColors, WsTypoVariants } from '../WsTypography';

export enum CardVariant {
  WITH_CONTAINED_BG = 'contained',
  WITH_LIGHT_BG = 'light',
  WITH_OUT_BG = 'nobg',
}

const mapColor = new Map();
mapColor.set('contained', WsColors.TheBlues800);
mapColor.set('light', WsColors.TheBlues50);
mapColor.set('nobg', WsColors.White);

const mapVariants = new Map();
mapVariants.set('contained', WsTypoColors.WHITE);
mapVariants.set('light', WsTypoColors.BLACK);
mapVariants.set('nobg', WsTypoColors.SECONDARY);

export interface WsCardProps {
  title?: string;
  middleComponent?: React.ReactElement;
  btnStartIcon?: React.ReactElement;
  btnEndIcon?: React.ReactElement;
  description?: string;
  buttonText?: string;
  cardType?: CardVariant;
  isButton: boolean;
  onClick?: React.MouseEventHandler;
  buttonSize?: WsButtonProps['size'];
  sx?: SxProps<Theme>;
}

const WsCard = ({
  title = '',
  middleComponent,
  description = '',
  buttonText = '',
  cardType = CardVariant.WITH_CONTAINED_BG,
  onClick,
  btnStartIcon,
  btnEndIcon,
  buttonSize = 'medium',
  sx,
}: WsCardProps) => {
  return (
    <Card
      sx={{ backgroundColor: mapColor.get(cardType), p: 2, ...sx }}
      onClick={(MouseEventHandler) =>
        isEmpty(buttonText) && onClick != null ? onClick(MouseEventHandler) : null
      }
    >
      {middleComponent != null && (
        <Grid container justifyContent="center" p={2}>
          {middleComponent}
        </Grid>
      )}
      <Box textAlign="center" px={6}>
        <WsTypography color={mapVariants.get(cardType)} variant={WsTypoVariants.TITLE}>
          {title}
        </WsTypography>
        <br />
        <WsTypography color={mapVariants.get(cardType)} variant={WsTypoVariants.BODY2}>
          {description}
        </WsTypography>
        <br />
        {!isEmpty(buttonText) && (
          <Box id={title === 'Post Manually' ? 'job_posting' : 'upload_jd'}>
            <WsButton
              variant={cardType === 'contained' ? 'contained' : 'outlined'}
              onClick={onClick}
              startIcon={btnStartIcon}
              endIcon={btnEndIcon}
              size={buttonSize}
            >
              {buttonText}
            </WsButton>
          </Box>
        )}
      </Box>
    </Card>
  );
};

export default WsCard;
